export const INFRASTRUCTURE_POLL_INTERVAL_MS = 60000; // 1 minute

export const MEASUREMENT_UNITS = {
  PERCENTAGE: "%",
  MILLISECONDS: "ms",
  SECONDS: "s",
  REQUESTS_PER_SECOND: "rps",
  BYTES: "Bytes",
};

export const InfrastructureTabEnum = {
  HOSTS: {
    value: "hosts",
    label: "Hosts",
  },
  CONTAINERS: {
    value: "containers",
    label: "Containers",
  },
  INTEGRATIONS: {
    value: "integrations",
    label: "Integrations",
  },
  SCRIPTS: {
    value: "scripts",
    label: "Scripts",
  },
};

export const AgentTypeEnum = {
  HOST: {
    label: "Host",
    value: "host",
    connectedAgentType: "snap",
  },
  APM: {
    label: "APM",
    value: "apm",
    connectedAgentType: "apm",
  },
  CLOUDWATCH: {
    label: "CloudWatch",
    value: "cloudwatch",
    connectedAgentType: "cloudwatch",
  },
};

export const PluginSidePanelEnum = {
  CONFIGURATION: {
    value: "configuration",
    label: "Configuration",
  },
  DASHBOARD: {
    value: "dashboard",
    label: "Dashboard",
  },
  METRICS: {
    value: "metrics",
    label: "Metrics",
  },
  ACTIONS: {
    value: "actions",
    label: "Actions",
  },
};
